import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageConstService {
  childrenFilter = 'childrenFilter';

  groupsFilter = 'groupsFilter';

  gradebookFilter = 'gradebookFilter';

  papPortfolioFilter = 'papPortfolioFilter';

  papPlanFilter = 'papPlanFilter';

  papAutoEvaluationFilter = 'papAutoEvaluationFilter';

  childrenPortfolioGroupAndChildrenFilter = 'childrenPortfolioGroupAndChildrenFilter';

  literacyFilter = 'literacyFilter';

  activityFilter = 'activityFilter';

  activityPageLimit = 'activityPageLimit';

  competenceFilter = 'competenceFilter';

  competencePageLimit = 'competencePageLimit';

  skillFilter = 'skillFilter';

  skillPageLimit = 'skillPageLimit';

  childrenPortfolioFilter = 'childrenPortfolioFilter';

  childrenPortfolioPageLimit = 'childrenPortfolioPageLimit';

  literacyPageLimit = 'literacyPageLimit';

  groupsPageLimit = 'groupsPageLimit';

  childrenPageLimit = 'childrenPageLimit';

  gradebookPageLimit = 'gradebookPageLimit';

  announcementPageLimit = 'announcementPageLimit';

  papPlanPageLimit = 'papPlanPageLimit';

  papPortfolioPageLimit = 'papPortfolioPageLimit';

  papAutoevaluationPageLimit = 'papAutoevaluationPageLimit';

  holidaysDatesPageLimit = 'holidaysDatesPageLimit';

  childProfileHistoryPageLimit = 'childProfileHistoryPageLimit';

  documentsPageLimit = 'documentsPageLimit';

  timelineFilter = 'timelineFilter';

  usersFilter = 'usersFilter';
}
